// extracted by mini-css-extract-plugin
export default {"zoomModal":"B4-z"};